import mlModelLinks from './mlModelLinks';

export default mlModelLinks;
